export default "__VITE_ASSET__OkheDNGc__"